var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscordLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24.381,
    viewBox: "0 0 32 24.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chba119gla"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 880",
    style: {
      fill: "#fff"
    },
    d: "M0 0h32v24.381H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "62595384f934b806f37f4956_145dc557845548a36a82337912ca3ac5",
    style: {
      clipPath: "url(#chba119gla)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1311",
    d: "M26.644 2.4A25.954 25.954 0 0 0 20.237.413a.1.1 0 0 0-.1.049 18.08 18.08 0 0 0-.8 1.639 23.96 23.96 0 0 0-7.2 0 16.582 16.582 0 0 0-.81-1.639.1.1 0 0 0-.1-.049A25.882 25.882 0 0 0 4.822 2.4a.092.092 0 0 0-.042.036A26.563 26.563 0 0 0 .13 20.351a.108.108 0 0 0 .041.074A26.1 26.1 0 0 0 8.03 24.4a.1.1 0 0 0 .11-.036 18.654 18.654 0 0 0 1.608-2.615.1.1 0 0 0-.055-.139 17.188 17.188 0 0 1-2.455-1.17.1.1 0 0 1-.01-.167c.165-.124.33-.252.488-.382a.1.1 0 0 1 .1-.014 18.613 18.613 0 0 0 15.817 0 .1.1 0 0 1 .1.013c.158.13.323.26.489.383a.1.1 0 0 1-.009.167 16.129 16.129 0 0 1-2.456 1.169.1.1 0 0 0-.053.14 20.945 20.945 0 0 0 1.607 2.614.1.1 0 0 0 .11.037 26.013 26.013 0 0 0 7.879-3.976.1.1 0 0 0 .041-.072 26.389 26.389 0 0 0-4.656-17.914.08.08 0 0 0-.041-.038zM10.517 16.775A3.025 3.025 0 0 1 7.689 13.6a3.009 3.009 0 0 1 2.829-3.172 2.992 2.992 0 0 1 2.828 3.172 3.009 3.009 0 0 1-2.829 3.175zm10.458 0a3.025 3.025 0 0 1-2.828-3.175 3.008 3.008 0 0 1 2.828-3.172A2.992 2.992 0 0 1 23.8 13.6a3 3 0 0 1-2.825 3.175z",
    transform: "translate(.186 -.229)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord_logo.16087423.svg";
export { ForwardRef as ReactComponent };